export const URL = "url";
export const ERROR = "error";
export const SESSION = "session";

export const resolveSessionType = (urlResult, storageResult) => {
  if (urlResult) return URL;
  else if (storageResult) return SESSION;
  else return 0;
};
